
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ats/attract-and-source",
      function () {
        return require("private-next-pages/ats/attract-and-source/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ats/attract-and-source"])
      });
    }
  